<template>
  <v-card>
    <v-card-title class="primary white--text headline">
      <span>{{ $t('chooseQrCodeType') }}</span>
      <v-spacer/>
      <Icon
        @icon-clicked="$emit('close-dialog')"
        :tooltipText="$t('close')"
        dataTestId="close-dialog-button"
        iconColor="white"
        icon="mdi-close"
        :small="false"
        large
        :disabled="isDownloading"
      />
    </v-card-title>
    <v-card-text class="pb-0">
      <v-container class="pa-0" fluid>
        <v-row no-gutters align="center">
          <v-col cols="4">
            <v-radio-group v-model="chosenTypeIndex" :disabled="isDownloading" class="mb-1 mr-4">
              <v-radio
                v-for="(type, i) in qrCodeTypes"
                :key="type"
                color="primary"
                :label="$t(type)"
                :value="i"
              />
            </v-radio-group>
          </v-col>
          <v-col v-if="chosenTypeIndex === 1" cols="8" class="mt-5">
            <v-checkbox
              v-model="individualTrailers"
              :label="$t('downloadIndividualTrailerQrCodes')"
              :disabled="isDownloading"
              hide-details
              dense
            />
          </v-col>
        </v-row>
        <v-select
          v-model="selectedTags"
          style="max-width: 75%;"
          :items="accountTags"
          item-text="value"
          item-value="tagId"
          return-object
          :label="$t('filterByTags')"
          :loading="accountTagsLoading"
          :disabled="isDownloading"
          multiple
          dense
        >
          <template #selection="{ item, index }">
            <v-chip close small @click:close="removeTag(index)">
              {{ item.value }}
            </v-chip>
          </template>
        </v-select>
        <div v-if="isDownloading">
          <v-progress-linear
            class="mt-n4"
            :value="progressPercent"
            color="primary"
            height="8"
            rounded
          />
          <span class="caption grey--text text--darken-1 mt-1 d-block">
            {{ $tc('processingQrCodes', downloadProgress, { current: downloadProgress, total: downloadTotal }) }}
          </span>
        </div>
      </v-container>
    </v-card-text>
    <v-card-actions class="pr-1 pt-0 pb-4">
      <v-spacer />
      <v-btn class="primary" :loading="isDownloading" :disabled="isDownloading" @click="startDownload">
        {{ $t('download') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AccountQrDownloadDialog',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    isDownloading: {
      type: Boolean,
      default: false
    },
    downloadProgress: {
      type: Number,
      default: 0
    },
    downloadTotal: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    chosenTypeIndex: 0,
    selectedTags: [],
    qrCodeTypes: ['account', 'driver'],
    individualTrailers: false
  }),

  computed: {
    ...mapGetters('tags', ['accountTags', 'accountTagsLoading']),
    progressPercent () {
      return this.downloadTotal > 0
        ? Math.round((this.downloadProgress / this.downloadTotal) * 100)
        : 0
    }
  },

  created () {
    this.fetchAccountTags()
  },

  methods: {
    ...mapActions('tags', ['fetchAccountTags']),

    removeTag (index) {
      this.selectedTags.splice(index, 1)
    },

    startDownload () {
      this.$emit('download', {
        type: this.qrCodeTypes[this.chosenTypeIndex],
        selectedTags: this.selectedTags,
        individualTrailers: this.individualTrailers
      })
    }
  }
}
</script>
